module.exports = __webpack_public_path__ + "img/6292666.svg";